export enum PackageCategory {
  LITE = 'LITE',
  BASIC = 'BASIC',
  PRO = 'PRO',
  ULTIMATE = 'ULTIMATE'
}
